import client from 'providers/fetchClient'

export const checkEmail = email => client.post('/users/check-email', { email })

export const redefinePassword = data => client.post('/users/redefine-password', data)

export const forgotPassword = email => client.post('/users/forgot-password', { email })

export const updatePassword = (id, data) => client.put(`/users/${id}/password`, data)
